import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import axios from "axios";
import { API_BASE_URL } from "./SignUp";

// 공지 생성, 수정, 삭제 토큰 가지고 잘 실행되는 것 확인 완료함.
const AnnouncementList: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  type Announcement = {
    id: number;
    title: string;
    content: string;
    writer: {
      accountId: string;
    };
    createdAt: string;
    updatedAt: string;
  };
  // 공지 리스트 조회 관련 상태
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  // 공지 상세 모달 관련 상태
  const [open, setOpen] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] =
    useState<Announcement | null>(null);

  // 리스트 조회 관련 기능
  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    axios
      .get(`${API_BASE_URL}/announcements`)
      .then((response) => {
        setAnnouncements(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  ////////////////////

  if (loading) {
    return (
      <Container style={{ textAlign: "center", padding: "50px" }}>
        <CircularProgress />
      </Container>
    );
  }

  // 공지 상세 모달 관련 함수
  const handleClickOpen = (announcement: Announcement) => {
    setSelectedAnnouncement(announcement);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedAnnouncement(null);
  };

  const shortenWords = (str: String, length = 24) => {
    let result: String = "";

    if (str.length > length) {
      result = str.substr(0, length - 2) + "...";
    } else {
      result = str;
    }

    return result;
  };

  return (
    <Container style={{ width: "100%", minWidth: "200px" }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        minWidth="200px"
        padding="20px 0"
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "white",
          zIndex: 1,
          borderBottom: "1px solid lightgray",
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ margin: "0" }}>
          공지 리스트
        </Typography>
      </Box>

      <Box
        sx={{
          overflowY: "auto",
          flexGrow: 1,
          maxHeight: "70%",
          padding: "0 10px",
        }}
      >
        {/* 스크롤 영역 */}
        {announcements.map((announcement: Announcement) => (
          <TableContainer
            component={Paper}
            sx={{
              margin: "10px 0 30px 0",
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
            }}
            key={announcement.id}
            onClick={() => handleClickOpen(announcement)}
            style={{ cursor: "pointer" }}
          >
            <Table
              sx={{
                background: "rgba(248, 248, 248, 0.767)",
              }}
            >
              <TableBody>
                <TableRow>
                  <TableCell>등록일</TableCell>
                  <TableCell>
                    {new Date(announcement.createdAt).toLocaleDateString()}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ width: "40px" }}>제목</TableCell>
                  <TableCell sx={{ width: "calc(100% - 40px)" }}>
                    {announcement.title}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>내용</TableCell>
                  <TableCell>{announcement.content}</TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell>수정일</TableCell>
                  <TableCell>
                    {new Date(announcement.updatedAt).toLocaleString()}
                  </TableCell>
                </TableRow> */}
              </TableBody>
            </Table>
          </TableContainer>
        ))}
      </Box>

      {/*공지 상세 모달*/}
      {selectedAnnouncement && (
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth="lg" // 최대 너비를 설정 (필요에 따라 조정)
          sx={{ maxWidth: "860px", width: "90%", margin: "0 auto" }}
        >
          <DialogTitle
            sx={{ wordWrap: "break-word", overflowWrap: "break-word" }}
          >
            {selectedAnnouncement.title}
          </DialogTitle>
          <DialogContent dividers>
            <Typography
              variant="body1"
              gutterBottom
              sx={{ wordWrap: "break-word", overflowWrap: "break-word" }}
            >
              {selectedAnnouncement.content}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              닫기
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Container>
  );
};

export default AnnouncementList;
